import React from 'react';
import Icon from '../../../components/AppIcon';

const AuthMethodSelector = ({ onMethodSelect, selectedMethod }) => {
  const methods = [
    {
      id: 'authenticator',
      name: 'Authenticator App',
      icon: 'Smartphone',
      description: 'Use an authenticator app like Google Authenticator or Authy',
      benefits: [
        'Works offline',
        'More secure than SMS',
        'No phone number required'
      ],
      requirements: [
        'Smartphone with camera',
        'Authenticator app installed'
      ]
    },
    {
      id: 'sms',
      name: 'SMS Verification',
      icon: 'MessageSquare',
      description: 'Receive verification codes via text message',
      benefits: [
        'Easy to set up',
        'No app required',
        'Works on any phone'
      ],
      requirements: [
        'Active phone number',
        'SMS reception capability'
      ]
    }
  ];

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-xl font-bold text-foreground mb-2">Choose Your Authentication Method</h2>
        <p className="text-muted-foreground">Select how you want to receive verification codes</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {methods?.map((method) => (
          <button
            key={method?.id}
            onClick={() => onMethodSelect(method?.id)}
            className={`text-left p-6 rounded-lg border-2 transition-all ${
              selectedMethod === method?.id
                ? 'border-primary bg-primary/5 shadow-lg'
                : 'border-border bg-card hover:border-primary/50 hover:shadow-md'
            }`}
          >
            <div className="flex items-start gap-4 mb-4">
              <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
                selectedMethod === method?.id ? 'bg-primary text-primary-foreground' : 'bg-muted'
              }`}>
                <Icon name={method?.icon} size={24} />
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-foreground mb-1">{method?.name}</h3>
                <p className="text-sm text-muted-foreground">{method?.description}</p>
              </div>
            </div>

            <div className="space-y-3">
              <div>
                <h4 className="text-sm font-medium text-foreground mb-2">Benefits:</h4>
                <ul className="space-y-1">
                  {method?.benefits?.map((benefit, idx) => (
                    <li key={idx} className="flex items-start gap-2 text-sm text-muted-foreground">
                      <Icon name="Check" size={16} className="text-success mt-0.5 flex-shrink-0" />
                      <span>{benefit}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <h4 className="text-sm font-medium text-foreground mb-2">Requirements:</h4>
                <ul className="space-y-1">
                  {method?.requirements?.map((req, idx) => (
                    <li key={idx} className="flex items-start gap-2 text-sm text-muted-foreground">
                      <Icon name="Circle" size={12} className="mt-1 flex-shrink-0" />
                      <span>{req}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default AuthMethodSelector;